import { render, staticRenderFns } from "./flex-grid.vue?vue&type=template&id=5df875be"
import script from "./flex-grid.vue?vue&type=script&lang=js"
export * from "./flex-grid.vue?vue&type=script&lang=js"
import style0 from "./flex-grid.vue?vue&type=style&index=0&id=5df875be&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports